export default "/images/f00392682fb7982929dcfe332c522172.avif";